import React from 'react';
import { Check } from 'lucide-react';

export const HabitCheckbox = ({ 
  checked, 
  onChange, 
  label, 
  sublabel,
  icon: Icon,
  color = 'cyan',
  testId
}) => {
  const colorClasses = {
    cyan: {
      bg: 'bg-cyan-400/20',
      border: 'border-cyan-400',
      fill: 'bg-cyan-400',
      text: 'text-cyan-400',
      glow: 'shadow-[0_0_10px_rgba(0,240,255,0.3)]'
    },
    purple: {
      bg: 'bg-purple-500/20',
      border: 'border-purple-500',
      fill: 'bg-purple-500',
      text: 'text-purple-500',
      glow: 'shadow-[0_0_10px_rgba(112,0,255,0.3)]'
    },
    lime: {
      bg: 'bg-lime-400/20',
      border: 'border-lime-400',
      fill: 'bg-lime-400',
      text: 'text-lime-400',
      glow: 'shadow-[0_0_10px_rgba(204,255,0,0.3)]'
    },
    amber: {
      bg: 'bg-amber-400/20',
      border: 'border-amber-400',
      fill: 'bg-amber-400',
      text: 'text-amber-400',
      glow: 'shadow-[0_0_10px_rgba(255,184,0,0.3)]'
    },
    rose: {
      bg: 'bg-rose-400/20',
      border: 'border-rose-400',
      fill: 'bg-rose-400',
      text: 'text-rose-400',
      glow: 'shadow-[0_0_10px_rgba(255,0,85,0.3)]'
    }
  };

  const colors = colorClasses[color] || colorClasses.cyan;

  return (
    <button
      onClick={() => onChange(!checked)}
      className={`flex items-center gap-4 p-4 rounded-2xl w-full transition-all duration-300 group ${
        checked 
          ? `${colors.bg} ${colors.glow}` 
          : 'bg-white/5 hover:bg-white/10'
      }`}
      data-testid={testId}
    >
      <div className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all duration-300 ${
        checked ? colors.fill : `${colors.bg}`
      }`}>
        {checked ? (
          <Check className="w-5 h-5 text-black" />
        ) : Icon ? (
          <Icon className={`w-5 h-5 ${colors.text}`} />
        ) : null}
      </div>
      
      <div className="flex-1 text-left">
        <span className={`font-medium transition-colors duration-300 ${
          checked ? colors.text : 'text-white/90'
        }`}>
          {label}
        </span>
        {sublabel && (
          <p className="text-xs text-white/40 mt-0.5">{sublabel}</p>
        )}
      </div>

      <div className={`w-6 h-6 rounded-lg border-2 flex items-center justify-center transition-all duration-300 ${
        checked 
          ? `${colors.border} ${colors.fill}` 
          : 'border-white/20'
      }`}>
        {checked && <Check className="w-4 h-4 text-black" />}
      </div>
    </button>
  );
};

export default HabitCheckbox;
